import _defineProperty from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

var _ORDER_STATE_TO_STEP_, _TRANSACTION_TYPE, _PAYMENT_TYPE;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import * as R from 'ramda';
import { ProductableType, StatusType } from '../types';
import { Categories, PaymentType, TransactionType } from '../types/order';
export var CATEGORIES_OTHER_THAN_THERAPY = [{
  productable_type: ProductableType['Pharmacy::Medicine::Identifier'],
  title: '保健食品/設備',
  key: Categories.DIETARY_SUPPLEMENT
}, {
  productable_type: ProductableType['MedicalCare::Examination'],
  title: '檢測',
  key: Categories.EXAMINATION
}, {
  productable_type: ProductableType['MedicalCare::WellnessProgram'],
  title: '線上課程',
  key: Categories.WELLNESS_PROGRAM
}, {
  productable_type: ProductableType['MedicalCare::Treatment'],
  title: '點滴/藥物處方/治療',
  key: Categories.TREATMENT
}, {
  productable_type: ProductableType['MedicalCare::OutpatientService'],
  title: '門診',
  key: Categories.OUTPATIENT_SERVICE
} // {
//   productable_type: 'Order::Discount',
//   title: '折價',
//   key: 'discounts',
// },
];
export var THERAPY_CATEGORY = {
  productable_type: ProductableType['MedicalCare::Therapy'],
  title: '療程',
  key: Categories.THERAPY
};
export var CATEGORIES = [THERAPY_CATEGORY].concat(CATEGORIES_OTHER_THAN_THERAPY);
export var PRODUCTABLE_TYPE_TO_FIELD_MAPS = R.reduce(function (acc, cur) {
  return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, cur.productable_type, cur.key));
}, {}, CATEGORIES);
export var ORDER_ITEM_KEYS = [Categories.MEDICATION];
export var SUB_ORDER_ITEM_KEYS = R.values(PRODUCTABLE_TYPE_TO_FIELD_MAPS);
export var PRODUCTABLE_TYPE_TO_CHINESE_MAP = R.fromPairs(R.map(R.props(['productable_type', 'title']))(CATEGORIES));
export var SORTED_SUB_ORDER_ITEM_CHINESE = R.map(R.propOr('', 'title'), CATEGORIES);
export var ORDER_STATUS = {
  initial: 0,
  checkout_in_progress: 100,
  payment_in_progress: 200,
  order_confirmed: 300,
  completed: 800,
  cancelled: 900
};
export var ORDER_STATE_TO_STEP_MAPS = (_ORDER_STATE_TO_STEP_ = {}, _defineProperty(_ORDER_STATE_TO_STEP_, ORDER_STATUS.initial, 0), _defineProperty(_ORDER_STATE_TO_STEP_, ORDER_STATUS.checkout_in_progress, 1), _defineProperty(_ORDER_STATE_TO_STEP_, ORDER_STATUS.payment_in_progress, 2), _defineProperty(_ORDER_STATE_TO_STEP_, ORDER_STATUS.order_confirmed, 3), _defineProperty(_ORDER_STATE_TO_STEP_, ORDER_STATUS.cancelled, 3), _defineProperty(_ORDER_STATE_TO_STEP_, ORDER_STATUS.completed, 5), _ORDER_STATE_TO_STEP_);
export var BILL_STATUS = {
  settled_full_sales_return: {
    key: 'settled_full_sales_return',
    translateKey: 'billSettled',
    returnStatus: 'orderReturn',
    scheme: StatusType.statusGray
  },
  settled_full_sales_allowance: {
    key: 'settled_full_sales_allowance',
    translateKey: 'billSettled',
    returnStatus: 'fullAllowance',
    scheme: StatusType.statusGray
  },
  settled: {
    key: 'settled',
    translateKey: 'billSettled',
    returnStatus: '',
    scheme: StatusType.statusGray
  },
  unsettled_full_sales_return: {
    key: 'unsettled_full_sales_return',
    translateKey: 'billNotSettledYet',
    returnStatus: 'orderReturn',
    scheme: StatusType.error
  },
  unsettled_full_sales_allowance: {
    key: 'unsettled_full_sales_allowance',
    translateKey: 'billNotSettledYet',
    returnStatus: 'fullAllowance',
    scheme: StatusType.error
  },
  unsettled: {
    key: 'unsettled',
    translateKey: 'billNotSettledYet',
    returnStatus: '',
    scheme: StatusType.error
  },
  abnormal: {
    key: 'abnormal',
    translateKey: 'abnormalPayment',
    returnStatus: '',
    scheme: StatusType.error
  }
};
export var ORDER_TYPE = {
  medical_prescription: {
    title: '醫事處方',
    i18n: 'order:medicalPrescription'
  },
  nutrition_planning: {
    title: '營養規劃',
    i18n: 'order:nutritionPlanning'
  },
  others: {
    title: '其他',
    i18n: 'order:sales.others'
  }
};
export var TRANSACTION_TYPE = (_TRANSACTION_TYPE = {}, _defineProperty(_TRANSACTION_TYPE, TransactionType.PAYMENT, {
  key: TransactionType.PAYMENT,
  id: 0,
  getDescription: function getDescription(t) {
    return t('payment:transactionDesc.payment', '收款 (客戶支付費用)');
  },
  getText: function getText(t) {
    return t('payment:transaction.payment', '收款');
  }
}), _defineProperty(_TRANSACTION_TYPE, TransactionType.REFUND, {
  key: TransactionType.REFUND,
  id: 1,
  getDescription: function getDescription(t) {
    return t('payment:transactionDesc.refund', '退款 (退回款項給客戶)');
  },
  getText: function getText(t) {
    return t('payment:transaction.refund', '退款');
  }
}), _TRANSACTION_TYPE);
export var TRANSACTION_TYPE_IDS = new Set(Object.values(TRANSACTION_TYPE).map(function (_ref) {
  var id = _ref.id;
  return id;
}));
export var PAYMENT_TYPE = (_PAYMENT_TYPE = {}, _defineProperty(_PAYMENT_TYPE, PaymentType.PAY_IN_FULL, {
  key: PaymentType.PAY_IN_FULL,
  id: 0,
  i18nKey: 'payment:types.' + PaymentType.PAY_IN_FULL,
  text: '一次支付'
}), _defineProperty(_PAYMENT_TYPE, PaymentType.PAY_IN_INSTALLMENTS, {
  key: PaymentType.PAY_IN_INSTALLMENTS,
  id: 1,
  i18nKey: 'payment:types.' + PaymentType.PAY_IN_INSTALLMENTS,
  text: '分期支付'
}), _PAYMENT_TYPE);